import type { SVGProps } from "react";
export interface MeatIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function MeatIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: MeatIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M.875 17.999A3.125 3.125 0 0 1 4 14.875h.534l1.67-1.67a1.125 1.125 0 0 1 1.59 1.59c-.292.293-.791.794-1.218 1.22l-.55.55-.23.23c-.212.21-.498.33-.796.33H4a.875.875 0 0 0 0 1.75c.62 0 1.125.504 1.125 1.125a.876.876 0 0 0 1.75 0v-1c0-.299.119-.585.33-.796l.23-.23.549-.55 1.22-1.22a1.125 1.125 0 1 1 1.59 1.591l-1.669 1.67V20a3.125 3.125 0 0 1-6.095.968A3.125 3.125 0 0 1 .875 18ZM14.645 5.64a1.126 1.126 0 0 1 1.505-.077l.085.077 2.123 2.123.078.085a1.125 1.125 0 0 1-1.584 1.583l-.085-.077-2.122-2.123-.078-.085a1.125 1.125 0 0 1 .078-1.506"
      />
      <path
        fill={color}
        d="M10.447 1.967c1.12-1.076 2.789-1.29 4.41-.93 1.675.372 3.477 1.378 5.101 3.002h.002c1.624 1.624 2.63 3.428 3.002 5.103.36 1.621.147 3.29-.928 4.41l-.677.746c-1.575 1.671-3.137 2.854-4.894 3.518-1.771.668-3.639.772-5.76.45l-.924-.163c-.198-.04-1.401-.267-2.382-1.127l-.193-.18c-.757-.756-1.09-1.707-1.226-2.225l-.081-.35c-.502-2.51-.477-4.66.287-6.684.758-2.009 2.194-3.761 4.263-5.571zM9.364 6.372A8.4 8.4 0 0 0 8.29 8.331c-.568 1.505-.636 3.2-.186 5.449l.056.234c.085.313.267.822.634 1.19h.001c.491.49 1.235.654 1.426.693l.819.145c1.851.28 3.313.166 4.63-.332a8.4 8.4 0 0 0 1.959-1.076q-.062-.01-.124-.022c-1.582-.337-3.28-1.231-4.828-2.684l-.307-.297C10.74 10 9.746 8.183 9.388 6.495q-.013-.06-.024-.123m5.006-3.138c-1.217-.27-2.007-.006-2.387.374-.383.384-.655 1.19-.394 2.418.255 1.198.999 2.642 2.369 4.013h.002c1.371 1.37 2.815 2.116 4.013 2.371 1.229.261 2.035-.01 2.419-.394.38-.38.643-1.17.373-2.386-.231-1.04-.838-2.27-1.909-3.482l-.487-.517c-1.376-1.376-2.811-2.132-4-2.397Z"
      />
    </svg>
  );
}
